import { MDBIcon, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import { FormEventHandler, useMemo } from "react";

export type InputType = "text"|"number"|"textarea"|"password";
export type ValueType = string | number;

export interface BaseInputProps {
    type: InputType;
    value: any;
    onValueChange?: (newValue: any) => void;
    label?: string;
    icon?: string;
    disabled?: boolean;
    rows?: number;
}

export const BaseInput = (props: BaseInputProps) => {
    
    const Input = useMemo(() => {
        switch(props.type){
            case "text":
            case "number":
            case "password":
                return <MDBInput
                    {...props}
                    onInput={ev => {
                        if (props.onValueChange) props.onValueChange(ev.currentTarget.value);
                    }}
                    autoComplete="off"
                />
            case "textarea":
                return <MDBTextArea
                    {...props}
                    onInput={ev => {
                        if (props.onValueChange) props.onValueChange(ev.currentTarget.value);
                    }}
                    autoComplete="off"
                />
            default:
                return null
        }
    }, [props]);

    return (
        <div className="d-flex flex-row align-items-center my-2">
            {props.icon && <MDBIcon icon={props.icon} className="me-2" fixed/>}
            {Input}
        </div>
    )
}